import { inject } from "@angular/core";
import { DashboardComponent } from "./features/dashboard/dashboard.component";
import { RegisterComponent } from "./features/register/register.component";
import { RootComponent } from "./features/root/root.component";
import { UnauthorizedComponent } from "./features/unauthorized/unauthorized.component";
import { AuthenticatedGuard } from "./guards/authenticated.guard";
import { NotAuthenticatedGuard } from "./guards/not-authenticated.guard";
import { inferRoute, NerriRoutes } from "./types/route.type";

export const ROUTES: NerriRoutes = [
    // Main redirect
    inferRoute({
        path: "",
        pathMatch: "full",
        component: RootComponent,
        canActivate: [() => inject(NotAuthenticatedGuard).canActivate()]
    }),

    // App components
    inferRoute({
        path: "dashboard",
        component: DashboardComponent,
        loadChildren: () => import("./features/dashboard/dashboard.routes"),
        canActivate: [() => inject(AuthenticatedGuard).canActivate()]
    }),
    inferRoute({
        path: "register",
        children: [
            inferRoute({ path: "", component: RegisterComponent }),
            inferRoute({ path: ":uuid", component: RegisterComponent })
        ]
    }),
    inferRoute({
        path: "unauthorized",
        component: UnauthorizedComponent
    })
];
